import { TranslateService } from './../../shared/translate/translate.service';
import { AuthService } from './../../shared/models/auth.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { CustomerModel } from '../models/customer.model';
import { CustomerService } from '../models/customer.service';
import { Observable } from 'rxjs/Observable';
import { WeGoConfig, IAPIResponse, ApplicationRouteURL, UserRoles, DataListModel, Permission, PermissionType, WeGoAuthorizedLink } from '../../shared/config';
import { ModalDirective } from 'ng2-bootstrap/components/modal';


@Component({
  selector: 'wego-customer',
  template: require('../views/customer-list.component.html'),
  providers: [CustomerService],
})
export class CustomerListComponent implements OnInit {
  DataListModel: DataListModel;
  customerList: CustomerModel[];
  apiErrorMsg: string;
  isLoading: boolean;
  customerHashId: string;
  message: string;
  urlDefaultPage: string;
  urlCustomerUpdate: string;
  urlCustomerAdd:string;
  urlRoleAvailability: string;
  urlInstanceList: string;
  private popupMsg: string;
  private module: string;
  private breadCrumbList: string;
  private popupTitle: string;
  private validationMessage: string;
  private urlAdminList:string;
  addCustomerLink: WeGoAuthorizedLink;

  @ViewChild('confirmModal') public confirmModal: any;
  @ViewChild('successPopup') public successPopup: any;
  @ViewChild('alertModal') public alertModal: ModalDirective;

  constructor(private customerService: CustomerService
    , private authService: AuthService
    , private translate: TranslateService) {
  }

  ngOnInit() {
    this.module = this.translate.instant('LblCustomer');
    this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
    this.DataListModel.searchField = ["customerName", "description"];
    this.urlDefaultPage = this.authService.GetURL(ApplicationRouteURL.URL_DEFAULT_PAGE);
    this.urlCustomerAdd = this.authService.GetURL(ApplicationRouteURL.URL_CUSTOMER_ADD);
    this.urlCustomerUpdate = this.authService.GetURL(ApplicationRouteURL.URL_CUSTOMER_UPDATE);
    this.urlRoleAvailability = this.authService.GetURL(ApplicationRouteURL.URL_ROLEAVAILABILITY_LIST);
    this.urlInstanceList = this.authService.GetURL(ApplicationRouteURL.URL_INSTANCE_LIST);
    this.urlAdminList =  this.authService.GetURL(ApplicationRouteURL.URL_ADMIN_OF_CUSTOMER_LIST);
    
    this.CustomerList();
    this.breadCrumbList = this.translate.instant('LblListPage', [this.module]);
    
    this.addCustomerLink = new WeGoAuthorizedLink(this.urlCustomerAdd, 
      Permission.PR_CUSTOMER_OVERVIEW, PermissionType.INSERT,'btn btn-highlight navbar-right', 'LblAddNew');
  }

  public OnSort(sortName: string) {
    this.DataListModel.sortType = sortName;
    this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
    this.CustomerList();
  }

  public OnSearch(event: any) {
    this.DataListModel = this.authService.GetSearchParameters(this.DataListModel, event.searchTerm, event.isReset);
    this.CustomerList();
  }

  public OnPageChanged(event: any): void {
    this.DataListModel.currentPage = event.page;
    this.CustomerList();
  };

  public OnPagingChange(event: any) {
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    this.DataListModel.itemsPerPage = event.itemPerPage;
    this.CustomerList();
  }
  public OnExport(event: any) {
    this.isLoading = true;
    this.customerService.ExportCustomerList(this.DataListModel)
      .subscribe(
      (res: any) => {
        if (res && res._body) {
          let fileName = "Customer" + new Date().toISOString() + ".csv";
          this.authService.DownloadFile(fileName, res._body);
        }
        this.isLoading = false;
      },
      (error: any) => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }

  public CustomerList() {
    this.isLoading = true;
    this.customerService.GetCustomerList(this.DataListModel)
      .subscribe(
      res => {
        this.customerList = res.data;
        this.DataListModel.totalItems = res.totalRecords;
        this.DataListModel.infoMessage = res.error;
        this.isLoading = false;
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }

  public DeleteCustomer(deleteCustomer: string) {
    this.isLoading = true;
    this.customerService.DeleteCustomers(deleteCustomer)
      .subscribe(
      res => {
        if (res.data) {
          this.DataListModel.currentPage = 1;
          this.CustomerList();
          this.popupMsg = this.translate.instant('LblRecordRemovedSuccess', [this.module]);
          this.ShowSuccessPopup();
        } else {
          this.validationMessage = res.error;
          this.popupTitle = this.translate.instant('LblWarning');
          this.ShowAlertModal();
        }
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }

  public ShowConfirmModal(customerMasterHashId?: string): void {
    this.customerHashId = customerMasterHashId;
    this.popupMsg = this.translate.instant('LblRecordDeleteConfirmation', [this.module]);
    this.customerHashId = customerMasterHashId;
    this.confirmModal.show();
  }

  public HideConfirmModal(): void {
    this.customerHashId = "";
    this.confirmModal.hide();
  }

  public SuccessModalClick(): void {
    this.DeleteCustomer(this.customerHashId);
    this.confirmModal.hide();
  }

  public ShowSuccessPopup(): void {
    this.successPopup.show();
  }

  public HideSuccessPopup(): void {
    this.successPopup.hide();
  }

  public ConfirmSuccessPopup(): void {
    this.successPopup.hide();
  }
  public SuccessAlertModalClick(): void {
    this.alertModal.hide();
  }

  public ShowAlertModal(): void {
    this.isLoading = false;
    this.alertModal.show();
  }

  ngOnDestroy() {
    this.authService.SetFilter(this.constructor.name, this.DataListModel);
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/customer/components/customer-list.component.ts